import React, { lazy, Suspense, memo } from "react";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import CustomLayout from "./CustomLayout";
import id_ID from "antd/locale/id_ID";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));
const HomeLayout = lazy(() => import("./HomeLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const homeLayout = useSelector((state) => state.theme.homeLayout);
  const customLayout = useSelector((state) => state.theme.customLayout);

  const Layout =
    token && !blankLayout
      ? !homeLayout
        ? customLayout
          ? CustomLayout
          : AppLayout
        : HomeLayout
      : AuthLayout;

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  return (
    <ConfigProvider theme={themeConfig} direction={direction} locale={id_ID}>
      <Suspense fallback={<Loading cover="content" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
